import { createMuiStyles } from '../../../utils/mui';

export const desktopHeaderStyles = createMuiStyles({
  toolbar: {
    height: {
      xs: '3.5rem',
      md: '4rem',
    },
  },
  logo: {
    textDecoration: 'none',
    mr: 4,
    fontWeight: 'Bold',
    display: 'block',
    img: {
      height: '3.5rem',
      width: 'auto',
    },
  },
  accountMenuContainer: {
    ml: 'auto',
    display: 'flex',
  },
  navLinkContainer: {
    width: '50%',
    flexWrap: 'nowrap',
    whiteSpace: 'nowrap',
    pr: 2,
    py: 2,
    mr: 4,
  },
  menuLink: {
    minWidth: 'auto',
    p: 0.5,
    maxWidth: '100%',
    width: 'max-content',
    textOverflow: 'ellipsis',
    height: 'auto',
    overflow: 'hidden',
    ':hover': {
      backgroundColor: 'transparent',
      color: 'primary.main',
    },
  },
  menuDropdown: {
    width: 'clamp(15rem, 30rem, 95vw)',
    p: 2.25,
  },
  menuDropdownIcon: {
    fontSize: '0.875rem',
  },
  dropdownListContainer: {
    whiteSpace: 'nowrap',
  },
  dropdownChildMenuContainer: {
    maxWidth: 'none!important',
    flexGrow: '1!important',
  },
  childMenuLink: {
    fontSize: '1rem',
    color: 'grey.800',
  },
  dropdownSubChildMenuContainer: {
    mt: 0.25,
    pt: 1.5,
    borderTop: 1,
    borderColor: 'grey.200',
  },
  subChildMenuLink: {
    maxWidth: '100%!important',
    '.MuiButton-root': {
      display: 'block',
    },
  },
  moreMenuDropdown: {
    p: 2.25,
    minWidth: '18rem',
    width: 'auto',
  },
  moreMenuParentLink: {
    fontSize: '1rem',
  },
  moreMenuDivider: {
    mt: 0.5,
    mb: 1,
  },
  skeletonMenuList: {
    display: 'flex',
    mr: 'auto',
  },
  skeletonMenu: {
    ml: 2,
  },
});
